function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmDb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "832pt",
    height: "258pt",
    viewBox: "0 0 832 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.594177%,9.812927%,9.423828%)",
      fillOpacity: 1
    },
    d: "M 0.0664063 257.984375 L 417.121094 257.984375 L 417.121094 0.0078125 L 0.0664063 0.0078125 Z M 0.0664063 257.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 341.457031 80.507813 L 292.914063 80.507813 L 295.902344 72.140625 L 341.457031 72.140625 Z M 341.457031 80.507813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 212.046875 72.136719 L 257.117188 72.132813 L 260.070313 80.523438 C 260.089844 80.511719 212.0625 80.535156 212.0625 80.523438 C 212.0625 80.511719 212.03125 72.140625 212.046875 72.140625 Z M 212.046875 72.136719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 176.25 72.136719 C 183.679688 72.851563 190.136719 75.5 195.636719 80.523438 C 195.636719 80.523438 113.941406 80.53125 113.941406 80.523438 C 113.941406 80.511719 113.941406 72.136719 113.941406 72.136719 Z M 176.25 72.136719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.828125 80.507813 L 106.585938 80.507813 L 106.585938 72.136719 L 49.828125 72.136719 Z M 49.828125 80.507813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 341.457031 96.214844 L 287.347656 96.214844 C 287.347656 96.214844 290.300781 87.886719 290.28125 87.882813 L 341.457031 87.882813 Z M 341.457031 96.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 265.644531 96.222656 L 212.042969 96.222656 L 212.042969 87.882813 L 262.707031 87.882813 Z M 265.644531 96.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 202 87.878906 C 203.078125 90.628906 204.351563 92.980469 204.351563 96.210938 L 113.957031 96.210938 L 113.957031 87.878906 Z M 202 87.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.828125 96.210938 L 106.585938 96.210938 L 106.585938 87.878906 L 49.828125 87.878906 Z M 49.828125 96.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 281.8125 111.957031 L 284.785156 103.589844 L 325.410156 103.601563 L 325.410156 111.9375 Z M 281.8125 111.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 268.253906 103.585938 L 271.210938 111.957031 L 228.027344 111.957031 L 228.027344 103.585938 Z M 268.253906 103.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 205.066406 103.585938 C 205.066406 106.453125 204.707031 109.445313 203.871094 111.957031 L 179.121094 111.957031 L 179.121094 103.585938 Z M 205.066406 103.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.648438 111.953125 L 90.042969 111.953125 L 90.042969 103.625 L 65.648438 103.625 Z M 65.648438 111.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.375 111.953125 L 154.726563 111.953125 L 154.726563 103.585938 L 130.375 103.585938 Z M 130.375 111.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 252.015625 120.992188 C 252.015625 120.992188 252.019531 127.328125 252.015625 127.339844 L 228.027344 127.339844 L 228.027344 119.011719 L 273.742188 119.011719 L 276.582031 126.777344 C 276.59375 126.78125 279.316406 118.992188 279.324219 119.007813 L 325.398438 119.007813 L 325.398438 127.339844 L 301.523438 127.339844 C 301.523438 127.328125 301.511719 120.996094 301.511719 120.996094 L 299.300781 127.339844 L 254.21875 127.328125 Z M 252.015625 120.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.375 119.007813 L 200.285156 119.007813 C 198.753906 121.796875 195.980469 125.1875 193.347656 127.339844 C 193.347656 127.339844 130.375 127.351563 130.375 127.339844 C 130.375 127.328125 130.375 119.023438 130.375 119.007813 Z M 130.375 119.007813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.648438 127.339844 L 90.042969 127.339844 L 90.042969 119.007813 L 65.648438 119.007813 Z M 65.648438 127.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 301.523438 143.042969 L 325.398438 143.042969 L 325.398438 134.714844 L 301.523438 134.714844 Z M 301.523438 143.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 252.015625 134.714844 L 228.027344 134.714844 L 228.027344 143.042969 C 228.011719 143.039063 252.019531 143.046875 252.019531 143.042969 C 252.019531 143.039063 252.046875 134.714844 252.015625 134.714844 Z M 252.015625 134.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 296.703125 134.714844 C 296.59375 134.703125 293.90625 143.039063 293.792969 143.042969 L 259.789063 143.058594 C 259.761719 143.046875 256.800781 134.703125 256.796875 134.714844 Z M 296.703125 134.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.371094 134.710938 L 193.230469 134.710938 C 196.097656 137.105469 198.691406 140.054688 200.722656 143.042969 C 200.839844 143.039063 130.375 143.046875 130.375 143.042969 C 130.375 143.039063 130.371094 134.722656 130.371094 134.710938 Z M 130.371094 134.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.039063 143.042969 L 90.039063 134.710938 L 65.6875 134.710938 C 65.6875 134.710938 65.695313 143.039063 65.6875 143.039063 C 65.683594 143.039063 90.027344 143.042969 90.039063 143.042969 Z M 90.039063 143.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 301.523438 158.75 L 325.394531 158.75 L 325.394531 150.417969 L 301.523438 150.417969 Z M 301.523438 158.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 228.023438 158.746094 L 252.015625 158.746094 L 252.015625 150.417969 L 228.023438 150.417969 Z M 228.023438 158.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 288.210938 158.789063 C 288.21875 158.75 291.15625 150.410156 291.199219 150.417969 L 262.292969 150.417969 C 262.242188 150.414063 265.257813 158.75 265.257813 158.75 C 265.257813 158.75 288.203125 158.824219 288.210938 158.789063 Z M 288.210938 158.789063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.375 158.746094 C 130.375 158.78125 130.371094 150.417969 130.375 150.417969 L 155.089844 150.417969 C 155.089844 150.417969 155.109375 158.75 155.089844 158.75 C 155.066406 158.75 130.375 158.742188 130.375 158.746094 Z M 130.375 158.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 204.191406 150.417969 C 205.386719 152.925781 205.507813 155.917969 205.746094 158.785156 L 179.558594 158.785156 L 179.558594 150.417969 Z M 204.191406 150.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.6875 158.746094 L 90.039063 158.746094 L 90.039063 150.417969 L 65.6875 150.417969 Z M 65.6875 158.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 301.523438 174.132813 L 341.457031 174.132813 L 341.457031 165.800781 L 301.523438 165.800781 Z M 301.523438 174.132813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 212.042969 174.132813 L 252.015625 174.132813 L 252.015625 165.800781 L 212.042969 165.800781 Z M 212.042969 174.132813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 282.839844 174.132813 L 270.648438 174.132813 L 267.722656 165.800781 L 285.660156 165.800781 Z M 282.839844 174.132813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.824219 165.800781 L 49.824219 174.128906 L 106.542969 174.128906 C 106.566406 174.144531 106.515625 165.804688 106.542969 165.804688 C 106.566406 165.804688 49.761719 165.800781 49.824219 165.800781 Z M 49.824219 165.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 204.707031 165.800781 C 204.109375 168.550781 203.5625 171.898438 201.554688 174.132813 L 200.804688 174.128906 L 113.953125 174.128906 L 113.953125 165.800781 Z M 204.707031 165.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 277.3125 189.855469 L 276.191406 189.855469 L 273.339844 181.503906 L 280.238281 181.503906 Z M 277.3125 189.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 301.523438 189.875 L 341.457031 189.875 L 341.457031 181.503906 L 301.523438 181.503906 Z M 301.523438 189.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.941406 189.855469 L 113.941406 181.519531 C 113.941406 181.519531 195.882813 181.53125 196.117188 181.53125 C 190.613281 186.789063 183.066406 189.757813 174.9375 189.875 L 113.953125 189.859375 Z M 113.941406 189.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 212.042969 189.875 L 252.015625 189.875 L 252.015625 181.503906 L 212.042969 181.503906 Z M 212.042969 189.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.542969 181.542969 C 106.542969 181.542969 106.515625 189.855469 106.542969 189.855469 C 106.566406 189.855469 49.84375 189.890625 49.824219 189.871094 C 49.8125 189.855469 49.839844 181.519531 49.824219 181.519531 C 49.8125 181.519531 106.515625 181.570313 106.542969 181.542969 Z M 106.542969 181.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 355.257813 172.960938 C 356.789063 172.960938 358.285156 173.351563 359.75 174.144531 C 361.207031 174.925781 362.347656 176.054688 363.160156 177.519531 C 363.976563 178.984375 364.382813 180.511719 364.382813 182.101563 C 364.382813 183.671875 363.984375 185.191406 363.179688 186.640625 C 362.375 188.09375 361.253906 189.222656 359.800781 190.023438 C 358.351563 190.828125 356.835938 191.230469 355.257813 191.230469 C 353.675781 191.230469 352.160156 190.828125 350.710938 190.023438 C 349.257813 189.222656 348.132813 188.09375 347.324219 186.640625 C 346.519531 185.191406 346.113281 183.671875 346.113281 182.101563 C 346.113281 180.511719 346.523438 178.984375 347.34375 177.519531 C 348.164063 176.054688 349.304688 174.925781 350.761719 174.144531 C 352.226563 173.351563 353.722656 172.960938 355.257813 172.960938 Z M 355.257813 174.472656 C 353.972656 174.472656 352.722656 174.804688 351.507813 175.460938 C 350.292969 176.117188 349.34375 177.058594 348.65625 178.28125 C 347.96875 179.503906 347.628906 180.777344 347.628906 182.101563 C 347.628906 183.417969 347.964844 184.675781 348.640625 185.882813 C 349.3125 187.089844 350.253906 188.03125 351.464844 188.707031 C 352.675781 189.378906 353.941406 189.71875 355.257813 189.71875 C 356.570313 189.71875 357.835938 189.378906 359.046875 188.707031 C 360.257813 188.03125 361.199219 187.089844 361.867188 185.882813 C 362.539063 184.675781 362.871094 183.417969 362.871094 182.101563 C 362.871094 180.777344 362.527344 179.503906 361.847656 178.28125 C 361.164063 177.058594 360.214844 176.117188 358.996094 175.460938 C 357.777344 174.804688 356.53125 174.472656 355.257813 174.472656 Z M 351.246094 187.140625 L 351.246094 177.324219 L 354.625 177.324219 C 355.78125 177.324219 356.617188 177.414063 357.132813 177.597656 C 357.652344 177.777344 358.0625 178.09375 358.371094 178.546875 C 358.679688 178.996094 358.832031 179.476563 358.832031 179.984375 C 358.832031 180.699219 358.574219 181.328125 358.058594 181.855469 C 357.546875 182.390625 356.863281 182.6875 356.015625 182.753906 C 356.359375 182.898438 356.640625 183.070313 356.847656 183.273438 C 357.246094 183.65625 357.730469 184.304688 358.304688 185.21875 L 359.5 187.140625 L 357.574219 187.140625 L 356.699219 185.59375 C 356.015625 184.375 355.457031 183.613281 355.035156 183.304688 C 354.746094 183.082031 354.324219 182.972656 353.765625 182.976563 L 352.832031 182.976563 L 352.832031 187.140625 Z M 352.832031 181.613281 L 354.757813 181.613281 C 355.679688 181.613281 356.308594 181.476563 356.640625 181.203125 C 356.976563 180.929688 357.144531 180.566406 357.144531 180.121094 C 357.144531 179.832031 357.0625 179.570313 356.902344 179.34375 C 356.742188 179.113281 356.519531 178.941406 356.234375 178.832031 C 355.945313 178.71875 355.414063 178.664063 354.636719 178.664063 L 352.832031 178.664063 Z M 352.832031 181.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.529358%,68.554688%,1.960754%)",
      fillOpacity: 1
    },
    d: "M 417.121094 256.523438 L 832.078125 256.523438 L 832.078125 -0.0390625 L 417.121094 -0.0390625 Z M 417.121094 256.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 488.617188 182.53125 L 488.617188 67.808594 L 520.296875 67.808594 C 560.710938 67.808594 580.945313 86.433594 580.945313 123.734375 C 580.945313 141.429688 575.320313 155.660156 564.097656 166.417969 C 552.875 177.148438 537.855469 182.53125 519.011719 182.53125 Z M 502.054688 79.960938 L 502.054688 170.378906 L 519.175781 170.378906 C 534.222656 170.378906 545.910156 166.335938 554.292969 158.28125 C 562.679688 150.222656 566.855469 138.808594 566.855469 124.035156 C 566.855469 94.652344 551.234375 79.960938 519.96875 79.960938 Z M 603.503906 182.53125 L 603.503906 67.808594 L 636.136719 67.808594 C 646.050781 67.808594 653.941406 70.238281 659.730469 75.074219 C 665.546875 79.933594 668.46875 86.269531 668.46875 94.050781 C 668.46875 100.550781 666.695313 106.203125 663.171875 111.007813 C 659.648438 115.816406 654.816406 119.230469 648.617188 121.25 L 648.617188 121.578125 C 656.34375 122.480469 662.542969 125.402344 667.1875 130.316406 C 671.828125 135.257813 674.148438 141.675781 674.148438 149.570313 C 674.148438 159.371094 670.625 167.320313 663.582031 173.410156 C 656.535156 179.496094 647.660156 182.53125 636.929688 182.53125 Z M 616.9375 79.960938 L 616.9375 117.019531 L 630.703125 117.019531 C 638.046875 117.019531 643.835938 115.242188 648.070313 111.691406 C 652.277344 108.140625 654.378906 103.144531 654.378906 96.671875 C 654.378906 85.53125 647.058594 79.960938 632.367188 79.960938 Z M 616.9375 129.085938 L 616.9375 170.378906 L 635.179688 170.378906 C 643.074219 170.378906 649.191406 168.492188 653.53125 164.78125 C 657.902344 161.039063 660.058594 155.902344 660.058594 149.40625 C 660.058594 135.859375 650.828125 129.085938 632.367188 129.085938 Z M 759.1875 182.53125 L 690.042969 182.53125 L 690.042969 170.839844 L 723.496094 137.335938 C 732.015625 128.789063 738.132813 121.6875 741.765625 116.007813 C 745.421875 110.328125 747.253906 104.265625 747.253906 97.792969 C 747.253906 91.183594 745.367188 86.078125 741.574219 82.445313 C 737.777344 78.8125 732.398438 77.011719 725.40625 77.011719 C 715.164063 77.011719 705.363281 81.378906 695.96875 90.117188 L 695.96875 76.355469 C 704.925781 69.363281 715.355469 65.871094 727.261719 65.871094 C 737.503906 65.871094 745.53125 68.65625 751.402344 74.199219 C 757.273438 79.742188 760.222656 87.199219 760.222656 96.535156 C 760.222656 103.882813 758.175781 111.0625 754.132813 118.082031 C 750.066406 125.101563 742.800781 133.8125 732.289063 144.214844 L 705.800781 170.378906 L 705.800781 170.679688 L 759.1875 170.679688 Z M 759.1875 182.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 773.4375 173.691406 C 774.96875 173.691406 776.464844 174.085938 777.925781 174.875 C 779.386719 175.660156 780.527344 176.785156 781.339844 178.25 C 782.152344 179.714844 782.5625 181.246094 782.5625 182.832031 C 782.5625 184.40625 782.160156 185.921875 781.355469 187.371094 C 780.554688 188.824219 779.429688 189.953125 777.980469 190.753906 C 776.53125 191.5625 775.015625 191.960938 773.4375 191.960938 C 771.855469 191.960938 770.339844 191.5625 768.886719 190.753906 C 767.4375 189.953125 766.308594 188.824219 765.503906 187.371094 C 764.699219 185.921875 764.292969 184.40625 764.292969 182.832031 C 764.292969 181.246094 764.703125 179.714844 765.519531 178.25 C 766.34375 176.785156 767.484375 175.660156 768.941406 174.875 C 770.402344 174.085938 771.898438 173.691406 773.4375 173.691406 Z M 773.4375 175.203125 C 772.152344 175.203125 770.898438 175.535156 769.683594 176.191406 C 768.46875 176.847656 767.519531 177.789063 766.835938 179.015625 C 766.148438 180.238281 765.804688 181.507813 765.804688 182.832031 C 765.804688 184.148438 766.144531 185.410156 766.816406 186.617188 C 767.492188 187.820313 768.433594 188.765625 769.644531 189.4375 C 770.855469 190.109375 772.117188 190.449219 773.4375 190.449219 C 774.75 190.449219 776.015625 190.109375 777.226563 189.4375 C 778.433594 188.765625 779.378906 187.820313 780.046875 186.617188 C 780.714844 185.410156 781.050781 184.148438 781.050781 182.832031 C 781.050781 181.507813 780.707031 180.238281 780.027344 179.015625 C 779.34375 177.789063 778.394531 176.847656 777.175781 176.191406 C 775.957031 175.535156 774.710938 175.203125 773.4375 175.203125 Z M 769.425781 187.871094 L 769.425781 178.054688 L 772.804688 178.054688 C 773.960938 178.054688 774.796875 178.144531 775.3125 178.328125 C 775.832031 178.507813 776.242188 178.824219 776.550781 179.277344 C 776.855469 179.726563 777.011719 180.207031 777.011719 180.714844 C 777.011719 181.429688 776.753906 182.058594 776.238281 182.585938 C 775.726563 183.121094 775.042969 183.417969 774.191406 183.484375 C 774.539063 183.628906 774.820313 183.800781 775.027344 184.003906 C 775.421875 184.386719 775.90625 185.039063 776.480469 185.949219 L 777.679688 187.871094 L 775.753906 187.871094 L 774.878906 186.328125 C 774.191406 185.105469 773.636719 184.34375 773.214844 184.039063 C 772.925781 183.8125 772.503906 183.703125 771.945313 183.707031 L 771.011719 183.707031 L 771.011719 187.871094 Z M 771.011719 182.34375 L 772.9375 182.34375 C 773.859375 182.34375 774.484375 182.207031 774.820313 181.933594 C 775.15625 181.660156 775.324219 181.296875 775.324219 180.851563 C 775.324219 180.5625 775.242188 180.300781 775.082031 180.074219 C 774.917969 179.84375 774.695313 179.675781 774.410156 179.5625 C 774.121094 179.453125 773.59375 179.394531 772.816406 179.394531 L 771.011719 179.394531 Z M 771.011719 182.34375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmDb2);
export default __webpack_public_path__ + "static/media/ibm_db2.de4cb78eaa4276d773f84359fa07f5d1.svg";
export { ForwardRef as ReactComponent };